export const MODULE_NAME = 'menu';

const prefix = `${MODULE_NAME}/`;

export const ACTION_TYPES = {
    SET_ACTIVE_CATEGORY: `${prefix}SET_ACTIVE_CATEGORY`,
    ENABLE_AUTO_UPDATE_ACTIVE_CATEGORY: `${prefix}ENABLE_AUTO_UPDATE_ACTIVE_CATEGORY`,
    ENABLE_AUTO_UPDATE_ACTIVE_MENU: `${prefix}ENABLE_AUTO_UPDATE_ACTIVE_MENU`,
    MENU_POSITION_DETAILS_FETCHED: `${prefix}MENU_POSITION_DETAILS_FETCHED`,
    MENU_POSITION_DETAILS_FETCH_DAILED: `${prefix}MENU_POSITION_DETAILS_FETCH_DAILED`,
    SET_ACTIVE_MENU: `${prefix}SET_ACTIVE_MENU`
};
